import { Injectable } from '@angular/core'
import { AppBasicService } from '@data/service/app-basic.service'
import { Observable, of } from 'rxjs'
import { map } from 'rxjs/operators'

import { HttpHeaders } from '@angular/common/http'

@Injectable()
export class HttpUserService extends AppBasicService {
   getCurrent(): Observable<any> {
      return this.http.get(`${this.configSevice.apiUrl}/users/current`, this.httpOptions).pipe(
         map((res: any) => {
            return this.dataSrv.mapUser(res, 'current')
         })
      )
   }

   getById(id: any): Observable<any> {
      return this.http.get(`${this.configSevice.apiUrl}/persons/${id}`, this.httpOptions).pipe(
         map((res: any) => {
            console.log('personssss', res)
            return this.dataSrv.mapPerson(res, 'detail')
         })
      )
   }

   getPrivacyStatementHTML(): Observable<any> {
      return this.http.get(`${this.configSevice.apiUrl}/persons/get-privacy-statement`, { ...this.httpOptions, responseType: 'text' }).pipe(
         map((res: any) => {
            console.log('dddd', res.split('<body>')[1].split('</body>')[0])
            return res.split('<body>')[1].split('</body>')[0]
         })
      )
   }

   updatePrivacyStatementPreference(id: any, accepted: boolean): Observable<any> {
      return this.http.put(`${this.configSevice.apiUrl}/persons/${id}/update-privacy-statement-acceptance/${accepted}`, { ...this.httpOptions }).pipe(
         map((res: any) => {
            console.log('res', res)
         })
      )
   }

   update(id: any, data: any): Observable<any> {
      if (data) {
         let params = data

         return this.http.put<any>(`${this.configSevice.apiUrl}/persons/${id}`, params, this.httpOptions)
      }

      return of(false)
   }

   uploadAvatar(id: any, file: any): Observable<any> {
      if (id != null && file) {
         let params = new FormData()
         params.append('file', file)

         const httpOptions = {
            headers: new HttpHeaders({
               //'Content-Type':  'multipart/form-data', // Fix bug empty boundary
               'Cache-control': 'no-cache',
            }),
         } //, responseType: 'text' as 'json'

         return this.http.post<any>(`${this.configSevice.apiUrl}/persons/${id}/avatar`, params, httpOptions)
      }

      return of(false)
   }

   deleteAvatar(id: any): Observable<any> {
      if (id != null) {
         return this.http.delete<any>(`${this.configSevice.apiUrl}/persons/${id}/avatar`, this.httpOptions)
      }

      return of(false)
   }

   registerConfirm(token: string): Observable<any> {
      if (token) {
         return this.http.post(`${this.configSevice.apiUrl}/users/verify/tokens/${token}`, {}, this.httpOptions)
      }

      return of(false)
   }

   uploadCv(id: any, file: any): Observable<any> {
      if (id != null && file) {
         let params = new FormData()
         params.append('file', file)

         return this.http.post<any>(`${this.configSevice.apiUrl}/persons/${id}/document`, params, {
            headers: new HttpHeaders({ 'Cache-control': 'no-cache' }),
            reportProgress: true,
            observe: 'events',
         })
      }

      return of(false)
   }

   deleteCv(id: any): Observable<any> {
      if (id != null) {
         return this.http.delete<any>(`${this.configSevice.apiUrl}/persons/${id}/document`, this.httpOptions)
      }

      return of(false)
   }

   feedback(data: any): Observable<any> {
      if (data) {
         let params = data

         return this.http.post<any>(`${this.configSevice.apiUrl}/feedback`, params, this.httpOptions)
      }

      return of(false)
   }
}
